import angular from 'angular';
import secureOneRosterApiConnectionComponent from './secureOneRosterApiConnection.component';

let secureOneRosterApiConnectionModule = angular.module('secureOneRosterApiConnection', []).component('secureOneRosterApiConnection', secureOneRosterApiConnectionComponent);

export default secureOneRosterApiConnectionModule;



// WEBPACK FOOTER //
// ./app/components/secureOneRosterApiConnection/secureOneRosterApiConnection.js